export default function MonitoringGoalsTable() {
  const rows = [
    {
      goal: "New content tracking",
      sort: "indexed_at",
      reason: "Avoids duplicates",
    },
    {
      goal: "Content change alerts",
      sort: "updated_at",
      reason: "Captures modifications",
    },
    {
      goal: "Real-time feeds",
      sort: "indexed_at",
      reason: "Chronological consistency",
    },
    {
      goal: "Analytics dashboards",
      sort: "indexed_at",
      reason: "Clean data progression",
    },
  ];

  return (
    <div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
      <table className="w-full border-collapse text-left">
        <thead className="bg-neutral-100">
          <tr>
            <th className="border-r border-neutral-200 px-4 py-3 text-sm font-bold text-neutral-950">
              Monitoring Goal
            </th>
            <th className="border-r border-neutral-200 px-4 py-3 text-sm font-bold text-neutral-950">
              Recommended Sort
            </th>
            <th className="px-4 py-3 text-sm font-bold text-neutral-950">
              Reason
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => (
            <tr key={idx} className="border-t border-gray-200">
              <td className="border-r border-neutral-200 px-4 py-3 text-sm leading-normal font-medium text-neutral-950">
                {row.goal}
              </td>
              <td className="border-r border-neutral-200 px-4 py-3 font-mono text-sm font-medium text-[#079300]">
                {row.sort}
              </td>
              <td className="px-4 py-3 text-sm leading-normal font-medium text-neutral-950">
                {row.reason}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
